import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environments';
import { SmsCampaignResponse } from '../models/responses/sms-campaign-response';

@Injectable({
  providedIn: 'root'
})
export class SmsCampaignService {

  constructor(private httpClient:HttpClient) { }

  schedule(aiAgentNumber:number,targetDate:Date,formData:FormData){
    return this.httpClient.post<SmsCampaignResponse>(`${environment.smsCampaignUrl}/schedule/${aiAgentNumber}/${targetDate}`,formData);
  }

  delete(id:number){
    return this.httpClient.delete<SmsCampaignResponse>(`${environment.smsCampaignUrl}/${id}`);
  }
}
